import { gql } from '@apollo/client'

/**
 * GraphQL Mutation Manual Add Payee.
 * @function MANUAL_ADD_PAYEES_MUTATION
 * Returns the GraphQL mutation string (e.g. `mutation createNewPayee { payeeId, payeeStatus }`).
 * @return {payeeId, payeeStatus} response data.
 */
/* E.g. variables: {
          appName: "BILLPAY",
          payeeCreateRequest: {
            name: name,
            nickName: nickname,
            payeeContactPhoneNumber: phonenumber,
            payeePostalAddress: {
              addressLine1: address1,
              addressLine2: address2,
              city: city,
              state: state,
              postalCode: zipcode,
            },
            payeeAccountInfo: [
              {
                accountNumber: accountnumber,
              },
            ],
          },
        }
} */
export const MANUAL_ADD_PAYEES_MUTATION = gql`
  mutation createBillpayPayee(
    $appName: AppNameEnum
    $payeeCreateRequest: BillpayPayeeCreateRequest
  ) {
    createBillpayPayee(
      appName: $appName
      payeeCreateRequest: $payeeCreateRequest
    ) {
      payee {
        payeeId
        payeeStatus
      }
    }
  }
`
export default MANUAL_ADD_PAYEES_MUTATION
